var _style, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _polyline, _path5, _polyline2, _path6, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateMenu01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9DA4A4;}\n\t.st1{fill:none;stroke:#DADEDE;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#DADEDE;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#2C3838;stroke-miterlimit:10;}\n\t.st4{fill:#DADEDE;}\n\t.st5{fill:#FFFFFF;stroke:#DADEDE;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st7{fill:#556262;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.56,19.84c1.1,0,2,0.9,2,2v29c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-29c0-1.1,0.9-2,2-2H60.56  M60.56,18.84h-50c-1.66,0-3,1.34-3,3v29c0,1.66,1.34,3,3,3h50c1.66,0,3-1.34,3-3v-29C63.56,20.19,62.22,18.84,60.56,18.84 L60.56,18.84z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.06,51.34h-26c-0.55,0-1-0.45-1-1v-28c0-0.55,0.45-1,1-1h26c0.55,0,1,0.45,1,1v28 C38.06,50.9,37.62,51.34,37.06,51.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.06,35.34h-19c-0.55,0-1-0.45-1-1v-12c0-0.55,0.45-1,1-1h19c0.55,0,1,0.45,1,1v12 C61.06,34.9,60.62,35.34,60.06,35.34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.06,51.34h-19c-0.55,0-1-0.45-1-1v-12c0-0.55,0.45-1,1-1h19c0.55,0,1,0.45,1,1v12 C61.06,50.9,60.62,51.34,60.06,51.34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.06,33.34c0,6-2,5-2,10v1c0,2.76-2.24,4-5,4l0,0c-7,0-11-8-11-15l0,0c0-4.97,4.03-9,9-9 S33.06,28.37,33.06,33.34L33.06,33.34z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.56,33.84c0,5-2.44,4.63-2.44,7.52v0.72c0,1.99,0.44,4.89-3.61,4.89l0,0c-5.06,0-8.94-7.78-8.94-12.83l0,0 c0-5.29,3.91-8.5,7.5-8.5c4.5,0,7.5,4.21,7.5,8.5V33.84z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 46.06,
    cy: 48.34,
    r: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 48.06,
    cy: 48.34,
    r: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 50.06,
    cy: 48.34,
    r: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 52.06,
    cy: 48.34,
    r: 0.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 54.06,
    cy: 48.34,
    r: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 47.06,
    cy: 46.34,
    r: 0.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 49.06,
    cy: 46.34,
    r: 0.5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 51.06,
    cy: 46.34,
    r: 0.5
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 53.06,
    cy: 46.34,
    r: 0.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 55.06,
    cy: 46.34,
    r: 0.5
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 56.06,
    cy: 48.34,
    r: 0.5
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "44.56,27.84 44.56,32.34 47.56,32.34 47.56,27.84 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.06,25.34c-0.09,0-0.18,0.02-0.26,0.03c-0.34-0.61-0.99-1.03-1.74-1.03s-1.39,0.42-1.74,1.03 c-0.09-0.01-0.17-0.03-0.26-0.03c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c0.75,0,1.39-0.42,1.74-1.03c0.09,0.01,0.17,0.03,0.26,0.03 s0.18-0.02,0.26-0.03c0.34,0.61,0.99,1.03,1.74,1.03c1.1,0,2-0.9,2-2C50.06,26.24,49.17,25.34,48.06,25.34z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "54.06,27.84 54.06,32.34 57.06,32.34 57.06,27.84 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.56,25.34c-0.09,0-0.18,0.02-0.26,0.03c-0.34-0.61-0.99-1.03-1.74-1.03s-1.39,0.42-1.74,1.03 c-0.09-0.01-0.17-0.03-0.26-0.03c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c0.75,0,1.39-0.42,1.74-1.03c0.09,0.01,0.17,0.03,0.26,0.03 s0.18-0.02,0.26-0.03c0.34,0.61,0.99,1.03,1.74,1.03c1.1,0,2-0.9,2-2C59.56,26.24,58.67,25.34,57.56,25.34z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.06,
    cy: 32.34,
    r: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateMenu01);
export default __webpack_public_path__ + "static/media/Empty-State-Menu-01.2901b725856a5a6579f257bf8dbcdfdf.svg";
export { ForwardRef as ReactComponent };